<template>
  <div class="score-area">
    <ul class="ques-list">
      <li v-for="item in progressList" :key="item.question_no">
        <p class="box"
           :class="{ active: item.question_no === activeNo }"
           @click="changeQues(item.question_no)">
          {{ item.question_no }}题<span>({{ item.done }}/{{ item.total }})</span>
        </p>
        <el-progress class="progress" :percentage="item.done/item.total*100" :stroke-width="4" color="#397EFD" :show-text="false"></el-progress>
      </li>
    </ul>
    <div class="main-content" id="mainContent">
      <p class="user-id">
        考生ID：{{ activeAnswer.userId }}
        <span class="click-text" @click="searchClick">快速查找</span>
      </p>
      <p class="title">
        <span class="name">{{ activeQuesInfo.questionName }}</span>
        <span class="score">（{{ activeQuesInfo.score }}分）</span>
        <span class="click-text" @click="openQuesDetail">查看题目</span>
      </p>
      <ul class="point-list" v-if="!noPoints">
        <li v-for="(item, index) in activeQuesInfo.points" :key="item.id">
          <p class="name">{{ item.name }}：</p>
          <el-input
            v-model="item.number"
            class="input"
            type="number"
            :step="activeQuesInfo.score_step"
            :max="item.score"
            :min="0"
            :placeholder="`请打分，共${item.score}分`"
            @change="((val) => { changeScore(val, index, item.score) })"
            @keyup.enter.native="changeScore(item.number, index, item.score)"
          ></el-input>
          <ul class="step-list" v-if="activeQuesInfo.score_step">
            <li
              class="flex-row-center"
              :class="{ active: item.number === 0 }"
              @click="changeScore(0, index)">0</li>
            <li
              class="flex-row-center"
              :class="{ active: item.number === s * activeQuesInfo.score_step }"
              v-for="(s, sIndex) in parseInt(item.score/activeQuesInfo.score_step)"
              :key="sIndex"
              @click="changeScore(s * activeQuesInfo.score_step, index)"
            >
              {{ s * activeQuesInfo.score_step }}
            </li>
            <li
              class="flex-row-center"
              :class="{ active: item.number === item.score }"
              v-if="item.score % activeQuesInfo.score_step !== 0"
              @click="changeScore(item.score, index)"
            >{{ item.score }}</li>
          </ul>
        </li>
      </ul>
      <div v-if="noPoints" class="no-point">
        <el-input
          v-model="noPointScore"
          class="input"
          type="number"
          :step="activeQuesInfo.score_step"
          :max="activeQuesInfo.score"
          :min="0"
          :placeholder="`请打分，共${activeQuesInfo.score}分`"
          @change="changeScore(noPointScore, 0, activeQuesInfo.score)"
          @keyup.enter.native="changeScore(noPointScore, 0, activeQuesInfo.score)"
        ></el-input>
        <ul class="step-list" v-if="activeQuesInfo.score_step">
          <li
            class="flex-row-center"
            :class="{ active: noPointScore === 0 }"
            @click="changeScore(0)">0</li>
          <li
            class="flex-row-center"
            :class="{ active: scoreSum === s * activeQuesInfo.score_step }"
            v-for="(s, sIndex) in parseInt(activeQuesInfo.score/activeQuesInfo.score_step)"
            :key="sIndex"
            @click="changeScore(s * activeQuesInfo.score_step)"
          >
            {{ s * activeQuesInfo.score_step }}
          </li>
          <li
            class="flex-row-center"
            :class="{ active: scoreSum === activeQuesInfo.score }"
            v-if="activeQuesInfo.score % activeQuesInfo.score_step !== 0"
            @click="changeScore(activeQuesInfo.score)"
          >{{ activeQuesInfo.score }}</li>
        </ul>
      </div>
      <p class="flex">
        <span class="name">得分：</span>
        <span class="score-sum">{{ !scoreSum && scoreSum !== 0 ? '-' : scoreSum }}<span>分</span></span>
      </p>
      <div class="mark">
        <p class="name">备注：</p>
        <el-input type="textarea" :rows="4" v-model="mark" placeholder="请输入备注，不超过300字（选填）" maxlength="300"></el-input>
      </div>
    </div>
    <div class="btn-wrap" v-if="activeAnswer.correctStatus === 0">
      <button type="button" class="prev-next-btn" @click="changeTask(1)" v-show="!isFirst">上一题</button>
      <button type="button" class="submit-btn" @click="submit(0)">提交</button>
    </div>
    <div class="btn-wrap" v-else>
      <button type="button" class="text" @click="changeTask(1)">上一题</button>
      <button type="button" class="text" @click="changeTask(2)">下一题</button>
      <button type="button" class="return-btn" @click="judgeBack(activeAnswer.questionNo)" v-if="!isDone">回到当前答题</button>
      <button type="button" class="submit-btn" @click="submit(1)">修改</button>
    </div>
    <div
      class="ques-detail"
      :class="{ show: showDetail }"
    >
      <i class="icon-close" @click="showDetail = false"></i>
      <div class="content">
        <p class="name">{{ activeQuesInfo.questionNo }}题：</p>

        <el-tabs v-if="activeQuesInfo.suite_type === 1" v-model="activeTab" type="card">
            <el-tab-pane label="题目要求" name="content">
            <div v-html="$xss(activeQuesInfo.rawDescription)"></div>
          </el-tab-pane>
          <el-tab-pane label="题目背景" name="background">
            <div class="modal-content" v-html="$xss(activeQuesInfo.suite_content)"></div>
          </el-tab-pane>
        </el-tabs>
        <div v-else v-html="$xss(activeQuesInfo.rawDescription)"></div>
        <button v-if="activeQuesInfo.questionType === 1" class="download-btn" @click="downloadFile"><icon-download class="icon-download"></icon-download>题目资料下载</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Progress, Input, MessageBox, Tabs, TabPane } from 'element-ui'
import IconDownload from '@/assets/svg/judge/download.svg'
import { downloadData } from '@/utils'

export default {
  components: {
    ElProgress: Progress,
    ElInput: Input,
    IconDownload,
    ElTabs: Tabs,
    ElTabPane: TabPane
  },
  props: {
    progressList: {
      type: Array
    },
    activeNo: {
      type: Number
    },
    activeQuesInfo: {
      type: Object
    },
    activeAnswer: {
      type: Object
    },
    isFirst: {
      type: Boolean
    },
    isDone: {
      type: Boolean
    }
  },
  watch: {
    activeQuesInfo(val) {
      this.noPoints = val.points.length === 0
    },
    activeAnswer(val) {
      this.initScore(val)
      this.$nextTick(() => {
        const inputs = document.getElementById('mainContent').getElementsByTagName('input')
        if (inputs.length > 0) {
          inputs[0].focus()
        }
      })
    }
  },
  data() {
    return {
      scoreSum: null,
      mark: '',
      showDetail: false,
      quesInfo: {},
      noPoints: false,
      noPointScore: null,
      activeTab: 'content'
    }
  },
  methods: {
    // 切换题目
    changeQues(no) {
      this.$emit('changeQuesNo', no)
    },
    // 回到当前答题
    judgeBack(no) {
      this.$emit('judgeBack', no)
    },
    // 打开题目详情
    openQuesDetail() {
      this.showDetail = !this.showDetail
    },
    // 动态计算总分
    changeScore(val, index, total) {
      val = !val && val !== 0 ? null : Number(val)
      if (total && this.activeQuesInfo.score_step) {
        if (val < 0 || val > total || (val < total && val % this.activeQuesInfo.score_step !== 0)) {
          val = null
        }
      }
      if (this.activeQuesInfo.points.length > 0) { // 有评分项
        this.$set(this.activeQuesInfo.points[index], 'number', val)
        this.scoreSum = null
        for (let i = 0; i < this.activeQuesInfo.points.length; i++) {
          this.scoreSum += this.activeQuesInfo.points[i].number
        }
      } else { // 无评分项
        this.noPointScore = val
        this.scoreSum = val
      }
      if (val !== null) {
        this.focusNextInput(index)
      }
    },
    // 切换任务 1-上一题  2-下一题
    changeTask(flag) {
      this.$emit('changeTask', flag)
    },
    // 提交评分
    submit(isEdit) {
      const scores = []
      let flag = 0
      this.activeQuesInfo.points.forEach(item => {
        if (item.number === null) {
          flag = 1
        }
        const data = {
          point_id: item.id,
          score: item.number
        }
        scores.push(data)
      })
      if (flag || (!scores.length && this.noPointScore === null)) {
        this.$message.error('评分未完成，请检查后提交！')
        return false
      }
      this.$emit('submit', scores, this.mark, isEdit, this.noPointScore)
    },
    // 处理input焦点聚焦
    focusNextInput(index) {
      const inputs = document.getElementById('mainContent').getElementsByTagName('input')
      for (let i = 0; i < inputs.length; i++) {
        // 如果是最后一个，则焦点跳到备注
        if (i === (inputs.length - 1)) {
          if (this.activeAnswer.correctStatus === 1) {
            this.submit(1)
          } else {
            this.submit(0)
          }
          break
        } else if (inputs[index] === inputs[i]) {
          inputs[i + 1].focus()
          break
        }
      }
    },
    // 已评分的任务初始化分数
    initScore(val) {
      if (this.activeQuesInfo.points.length > 0) {
        this.activeQuesInfo.points.forEach((item) => {
          this.$set(item, 'number', null)
        })
      }
      if (val.basketPoints.length > 0) { // 有成绩
        val.basketPoints.forEach((item, index) => {
          this.$set(this.activeQuesInfo.points[index], 'number', item.score)
        })
      } else {
        if (val.correctStatus === 1) {
          this.noPointScore = val.score
        } else {
          this.noPointScore = null
        }
      }
      if (val.correctStatus === 1) {
        this.scoreSum = val.score
      } else {
        this.scoreSum = null
      }
      this.mark = val.note
    },
    downloadFile() {
      downloadData(this.activeQuesInfo.uploadUrl)
    },
    searchClick() {
      MessageBox.prompt('', '', {
        title: `快速查找(${this.activeNo}题)`,
        confirmButtonText: '查看答卷',
        showCancelButton: false,
        inputPlaceholder: '请输入需要快速查看的考生ID',
        center: true,
        inputValidator: (value) => {
          if (!value) {
            return '请输入考生ID'
          }
          const userId = value.trim()
          if (!/^[0-9]{1,}$/.test(userId)) {
            return '考生ID输入格式不正确'
          }
          if (userId > Math.pow(2, 31) - 1) {
            return '考生ID不正确'
          }
          if (+userId === this.activeAnswer.userId) {
            return '正在批阅该考生试卷'
          }
          return true
        }
      }).then(({ value }) => {
        this.$emit('changeStudentID', value.trim())
      }).catch((e) => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  .score-area {
    width: 500px;
    max-height: 100%;
    background-color: #fff;
    padding: 20px 20px 0 20px;
    box-shadow: -4px 0px 12px 0px rgba(57,126,253,0.1);
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .ques-list {
    border-bottom: 1px solid #E8E8E8;
    display: flex;
    flex-wrap: wrap;
    max-height: 208px;
    overflow-y: scroll;
    li {
      margin: 0 10px 20px 0;
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
    .box {
      width: 136px;
      height: 30px;
      line-height: 30px;
      border-radius: 2px;
      border: 1px solid #397EFD;
      text-align: center;
      color: $themeColor;
      font-size: 14px;
      cursor: pointer;
      span {
        display: inline-block;
        font-size: 12px;
        margin-left: 16px;
      }
      &:hover {
        background-color: rgba(56, 126, 253, .08);
      }
      &.active {
        background-color: $themeColor;
        color: #fff;
      }
    }
    .progress {
      margin-top: 15px;
    }
  }
  .btn-wrap {
    text-align: center;
    border-top: 1px solid #E8E8E8;
    padding: 22px 0;
    .text {
      width: 60px;
      font-size: 14px;
      color: $themeColor;
      cursor: pointer;
      margin-right: 10px;
      background-color: #fff;
    }
  }
  .return-btn {
    @include theme-empty-btn(128px, 36px, 14px, 4px);
    margin-right: 30px;
  }
  .prev-next-btn {
    @include theme-empty-btn(128px, 36px, 14px, 4px);
    margin-right: 26px;
  }
  .submit-btn {
    @include theme-fill-btn(128px, 36px, 14px, 4px);
  }
  .main-content {
    padding-top: 20px;
    flex: 1;
    overflow-y: scroll;
    padding-bottom: 50px;
  }
  .user-id {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin: 10px 0 30px 0;
  }
  .title {
    margin-bottom: 30px;
    .score {
      color: #666;
    }
  }
  .click-text {
    color: $themeColor;
    margin-left: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: normal;
  }
  .name {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    margin-bottom: 8px;
  }
  .point-list {
    li {
      margin-bottom: 16px;
    }
    .input {
      margin: 0 0 12px 0;
    }
  }
  .no-point {
    margin-bottom: 16px;
    .input {
      margin: 0 0 12px 0;
    }
  }
  .step-list {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 30px;
      height: 30px;
      border-radius: 2px;
      border: 1px solid rgba(56, 126, 253, .4);
      margin: 0 10px 10px 0;
      color: $themeColor;
      font-size: 14px;
      cursor: pointer;
      &:nth-child(11n) {
        margin-right: 0;
      }
      &:hover {
        background-color: rgba(56, 126, 253, .08);
      }
      &.active {
        background-color: $themeColor;
        color: #fff;
      }
    }
  }
  .mark {
    margin-top: 35px;
  }
  .score-sum {
    display: inline-block;
    font-size: 24px;
    color: #FF8000;
    span {
      font-size: 14px;
      color: #333;
      margin-left: 5px;
    }
  }
  /deep/input::-webkit-outer-spin-button,
  /deep/input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
  /deep/input[type="number"] {
    -moz-appearance: textfield !important;
  }
  .ques-detail {
    position: absolute;
    right: 500px;
    top: 0;
    bottom: 0;
    width: 0;
    background-color: #fff;
    box-shadow: 0 4px 14px 0 rgba(57, 126, 253, .2);
    text-align: left;
    transition: width ease .3s;
    &.show {
      width: 500px;
      padding: 0 20px;
      .icon-close {
        display: inline-block;
      }
    }
    .icon-close {
      display: none;
      width: 16px;
      height: 16px;
      background: url("~@/assets/images/judge/icon-close.png") center / cover no-repeat;
      float: right;
      cursor: pointer;
      margin: 30px 12px 0 0;
    }
    .content {
      padding-top: 52px;
      font-size: 16px;
      color: $titleColor;
      line-height: 27px;
      overflow: scroll;
      height: 100%;
      /deep/ img {
        max-width: 100%;
      }
    }
    .download-btn {
      width: 160px;
      height: 42px;
      border-radius: 4px;
      border: 1px solid #397EFD;
      background: rgba(56, 126, 253, 0.03);
      color: $themeColor;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin: 20px 0 30px 0;
      &:hover {
        background: $themeColor;
        color: #fff;
        .icon-download {
          fill: #fff;
        }
      }
    }
    .icon-download {
      display: inline-block;
      fill: $themeColor;
      margin-right: 6px;
    }
  }
.modal-content {
  font-size: 16px;
  margin-bottom: 24px;
  text-align: left;
}
</style>
